import type ILabelEnumPair from '../../../global/GlobalInterfaces';
import type { ICompany } from '../../../massReceive/MassReceiveInterfaces';

interface IRuleCondition {
  field: string;
  collectionOperator?: string;
  operation: string;
  value: string;
}

export const emptyRuleCondition = (): IRuleCondition => ({
  field: '',
  operation: '',
  value: '',
});

export const emptyMarkingDynamicBehaviorCondition = (): IMarkingDynamicBehavior => ({
  department: null,
  title: '',
  message: '',
});

interface IRuleOutcome {
  field: string,
  operation: string,
  value: string,
}

interface IViewAllRulesQuery {
  company?: ICompany,
  workflowName: string,
  conditions: IRuleCondition[],
  outcomes: IRuleOutcome[],
}

interface IRule {
  ruleName?: string,
  companyName?: string,
  conditionField?: string,
  conditionOperator?: string,
  conditionCollectionOperator?: string,
  conditionValue?: string,
  outcomeField?: string,
  outcomeOperator?: string,
  outcomeValue?: string,
}

interface IRuleDetailQuery {
  workflow: string;
  ruleName: string;
}

interface IRuleDetail {
  company?: ICompany,
  conditions: IRuleCondition[],
  outcomes: IRuleOutcome[],
  isQuantity: boolean,
}

interface ICreateRuleCommand {
  isEdit: boolean,
  ruleName?: string,
  workflowName: string,
  company?: ICompany,
  conditions: IRuleCondition[],
  outcomes: IRuleOutcome[],
  isQuantity?: boolean,
}

interface EnumObject {
  [enumValue: number]: string;
}

interface IMarkingDynamicBehavior {
  department?: ILabelEnumPair | null,
  title?: string,
  message?: string,
}

export type RuleFiltersModes = 'Create' | 'Edit' | 'Filter' | 'Clone';

export type {
  IRule,
  IRuleCondition,
  IRuleOutcome,
  IViewAllRulesQuery,
  IRuleDetail,
  EnumObject,
  IMarkingDynamicBehavior,
  IRuleDetailQuery,
  ICreateRuleCommand,
};

export enum POLICYCONFIGURATORSECTIONS {
  PRICING = 'Pricing',
  MARKING = 'Marking',
  ROUTING = 'Routing',
  MARKINGDYNAMICBEHAVIOR = 'Marking Dynamic Behavior',
  PHOTOGRAPHYDYNAMIC = 'Photography Dynamic',
}

export enum PRICINGWORKFLOWS {
  WARRANTY = 'Warranty',
  JOBCODE = 'Job Code',
  LABORCODE = 'Labor Code',
  PARTCODE = 'Part Code',
}

export enum MARKINGDYNAMICBEHAVIORWORKFLOWS {
  MARKINGDYNAMICBEHAVIOR = 'Marking Dynamic Behavior',
}

export enum PHOTOGRAPHYDYNAMICWORKFLOWS {
  PHOTOGRAPHYDYNAMIC = 'Photography Dynamic',
}

export enum MARKINGWORKFLOWS {
  ADDITIONALFIELD = 'Additional Field',
}

export enum ROUTINGWORKFLOWS {
  DestinationStandardOperations = 'Destination - Standard Operations',
  DestinationRepairTypes = 'Destination - Repair Types',
  DestinationJobs = 'Destination - Jobs',
  DestinationLocation = 'Destination - Location',
  DestinationClient = 'Destination - Client',
  DestinationManufacturer = 'Destination - Manufacturer',
  DestinationNuclear = 'Destination - Nuclear',
  WORKBALANCING = 'Skill Level',
}

export const arbitraryInputAllowedWorkflowTypes : string[] = ['Name'];

export const companyRequiredWorkflowTypes : string[] = [PRICINGWORKFLOWS.LABORCODE, PRICINGWORKFLOWS.PARTCODE];
